module.exports = __webpack_public_path__ + "StarStatusInfo-c85fb08bab76908057a74de13ce6050b.png";